import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=4d2318f8&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=4d2318f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2318f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2318f8')) {
      api.createRecord('4d2318f8', component.options)
    } else {
      api.reload('4d2318f8', component.options)
    }
    module.hot.accept("./DragAndDrop.vue?vue&type=template&id=4d2318f8&scoped=true", function () {
      api.rerender('4d2318f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/repositorio/DragAndDrop.vue"
export default component.exports